let Api = {
  //基地管理
  ENTPBASEMAGE_EXPORTEXCEL: "/difam/w/entpBaseMage/exportExcel", //下载模版
  ENTPBASEMAGE_IMPORTEXCEL: "/difam/w/entpBaseMage/importExcel", //导入
  ENTPBASEMAGE_DEL: "/difam/w/entpBaseMage/del", //删除
  ENTPBASEMAGE_FINDINFO: "/difam/w/entpBaseMage/findInfo", //查询详细信息
  ENTPBASEMAGE_SAVEORUPDATE: "/difam/w/entpBaseMage/saveOrUpdate", //新增或修改
  N_TYPECOUNT: "/difam/n/typeCount", //基地分布列表类型统计
  N_FINDDISTLIST: "/difam/n/findDistList", //查询基地分布列表
  COF_SAVEORUPDATE: "/difam/w/conf/saveOrUpdate", //新增或修改产业基地配置信息
  COF_FINDDEFAULT: "/difam/w/conf/findDefault", //查询默认产业基地配置信息
  N_FINDDEFAULT: "/difam/n/findDefault", //配置详情
  N_DATA_FINDLIST: "/difam/w/data/entp/findList", //全部基地列表
  N_DATA_FINDINFO: "/difam/w/data/entp/findInfo", //基地详情
  N_DATA_FINDDATA: "/difam/w/data/entp/findData", //基地相关数据统计
  N_WAM_FINDPAGELIST: "/difam/n/data/entp/wam/findPageList", //分页预警记录列表
  N_DATA_SELSOILEQULIST: "/difam/w/data/entp/selSoilEquList", //数据管理 - 土壤数据
  N_DATA_SELSOILEQUAIRLIST: "/difam/w/data/entp/selSoilEquAirList", //数据管理 - 土壤数据-湿度
  N_DATA_SELWEATHEREQULIST: "/difam/w/data/entp/selWeatherEquList", //数据管理 - 气象数据
  N_DATA_SELWEATHEREQUAIRLIST: "/difam/w/data/entp/selWeatherEquAirList", //数据管理 - 气象数据

  ENTPPORTALMODULEMAGE_FINDINFO: "/difam/n/entpPortalModuleMage/findInfo", //企业门户-->查看模块详情
  "EQU_SEARCH_DATEPOINTSTATISTICS": "/difam/n/equ/search/datePointStatistics", //设备按 当天、近7天、近30统计
  ENTP_SELEQULIST: "/difam/n/data/entp/selEquList", //数据管理
  N_FINDINFO: "/difam/n/findInfo", //查询基地详情
  //交易大数据
  TRADE_AREASALE: "/operations/w/trade/areaSale", //地区成交排名
  TRADE_CATGSALE: "/operations/w/trade/catgSale", //品类销售价格指数
  TRADE_COMMSALE: "/operations/w/trade/commSale", //交易产品销售排名
  TRADE_INDUSTRY: "/operations/w/trade/industry", //产业交易通道总金额
  TRADE_SALETREND: "/operations/w/trade/saleTrend", //产业交易通道总金额
  TRADE_SALECHANNEL: "/operations/w/trade/salesChannel", //销售渠道占比
  TRADE_SHOPSALE: "/operations/w/trade/shopSale", //商家店铺销售排名
  N_PORTAL_VARIETY_LIST: "/portal-api/n/variety/listCountData",
  // 追溯大数据
  N_RETRO_PRODUCTTRENDLIST: "/retro/n/bigData/productTrendList", //大数据-追溯产品验证趋势
  N_RETRO_MEMBUSEPHLIST: "/retro/n/bigData/membUsePhList", //大数据-近一年主体使用排行
  N_RETRO_ZSPCPAGELIST: "/retro/n/bigData/zsPcPageList", //大数据-追溯码生成记录
  N_RETRO_STATISTICEFORMAP: "/retro/n/bigData/statisticeForMap", //大数据-地图显示的统计数据
  N_RETRO_CXJLPAGE: "/retro/n/bigData/cxJlPage", //大数据-追溯查询记录分页列表
  N_RETRO_CXJLFORMAP: "/retro/n/bigData/cxJlForMap", //大数据-查询地图显示的追溯扫码记录(根据市)
  QUALITY_FINDHGZUSELIST: "/quality/w/CertificateInfo/findHgzUseList", //大数据-合格证使用趋势
  QUALITY_NEARLYUSELIST: "/quality/w/CertificateInfo/nearlyYearSubjectUseList", //大数据-近一年主体使用排行
  QUALITY_HGCREATELIST: "/quality/w/CertificateInfo/hgzCreateList", //大数据-合格证生成记录
  N_GETWEATHER: "/difam/n/getWeather", //获取天气信息 接口每天免费调用2000次
  SYNC_FINDLIST: "/operations/w/sync/findList", //查询各个渠道订单列表
  //基地设备
  ENTPBASEMAGE_FINDLIST: "/difam/w/entpBaseMage/findList", //基地查询列表
  ENTPBASELINK_FINDPAGELIST: "/difam/w/EntpBaseLink/findPageList", //分页查询列表
  ENTPBASELINK_DEL: "/difam/w/EntpBaseLink/del", //删除
  ENTPBASELINK_SAVEORUPDATE: "/difam/w/EntpBaseLink/saveOrUpdate", //新增或修改
  //基地商品
  ENTPBASEPRODUCT_FINDPAGELIST: "/difam/w/EntpBaseProduct/findEntpBasePageList", //基地产品分页查询列表
  ENTPBASEPRODUCT_DEL: "/difam/w/EntpBaseProduct/del", //删除
  ENTPBASEPRODUCT_SAVEORUPDATE: "/difam/w/EntpBaseProduct/saveOrUpdate", //新增或修改
  ENTPBASEPRODUCT_FINDLIST: "/difam/w/EntpBaseProduct/findPageList", //产品查询列表
  ENTPBASEPRODUCT_SAVE: "/difam/w/EntpBaseProduct/save", //产品新增保存
  //科右大数据
  TRADE_KY_SALETREND: "/operations/w/trade/ky/saleTrend", //产业交易通道总金额
  TRADE_KY_SALECHANNEL: "/operations/w/trade/ky/salesChannel", //销售渠道占比
  TRADE_KY_SHOPSALE: "/operations/w/trade/ky/shopSale", //商家店铺销售排名
  TRADE_KY_MEMBTREND: "/operations/w/trade/ky/membTrend", //会员增长
  TRADE_KY_AREASALE: "/operations/w/trade/ky/areaSale", //订单销售地区
  TRADE_KY_CATGSALE: "/operations/w/trade/ky/catgSale", //品类销售价格指数
  TRADE_KY_INDUSTRY: "/operations/w/trade/ky/industry", //产业交易通道总金额
  TRADE_KY_SALETRENDYEAR: "/operations/w/trade/ky/saleTrendYear", //交易产品销售排名
  "TRADE_KY_FINDLIST": '/operations/w/trade/ky/findList',//
  "TRADE_KY_COMMSALE": '/operations/w/trade/ky/commSale',//交易产品销售排名
 // 华南中药材
 TRADE_KY_SHOPSALES: "/operations/w/trade/ky/shopSale", //私域流量接口--企业销售排名
 TRADE_KY_YEARSALE: "/operations/w/trade/ky/yearSale", //年度交易额-月销售情况
 TRADE_KY_SALENAME: "/operations/w/trade/ky/saleName", //三级品类名称销售价格指数

 //科右交易一张图接口

 TRADE_NY_INDUSTRY: "/simple-api/n/ky/trade/industry", //产业交易通道总金额>科右
 TRADE_NY_SALENAME: "/simple-api/n/ky/trade/saleName", //品类销售价格指数>科右
 TRADE_NY_FINDLIST: "/simple-api/n/ky/trade/findList", //查询渠道订单列表>科右
 TRADE_NY_YEARSALE: "/simple-api/n/ky/trade/yearSale", //年度交易额-月销售情况>科右
//  TRADE_NY_SHOPSALES: "/operations/w/trade/ny/shopSale", //私域流量接口--企业销售排名>科右
 TRADE_NY_SALETRENDYEAR: "/simple-api/n/ky/trade/saleTrendYear", //交易销售年度趋势>科右
 TRADE_NY_TRADE_AREASALE: "/simple-api/n/ky/trade/areaSale", //交易/销售地区占比


  //产业总览
  CYZL_BREADSPREADLIST: "/difam/w/farmCyzl/breadSpreadList",
  CYZL_SCALELIST: "/difam/w/farmCyzl/scaleList",
  CYZL_VARIETYSPREADLIST: "/difam/w/farmCyzl/varietySpreadList",
  CYZL_BREBIRDLIST: "/difam/w/farmCyzl/brebirdList",
  FARMCYZL_NEARTWELVEMONTH: "/difam/w/farmCyzl/nearTwelveMonth", // 近12个月发展趋势
  FARMCYZL_NEARFIVEYEAR: "/difam/w/farmCyzl/nearFiveYear", // 近五年产业发展概况

  FARMCYZL_PROJECTINDEX: "/difam/w/farmCyzl/projectForIndex", // 产业扶持情况
  FARMCYZL_PRICEINDEXLIST: "/difam/w/farmCyzl/priceIndexList", // 产地价格指数

  //追溯中心
  ZSZX_FINDPAGE: "/trace/w/traceDataSource/findPage", // 数据源分页查询
  ZSZX__SAVE: "/trace/w/traceDataSource/save", // 数据源新增
  ZSZX__GETDETAIL: "/trace/w/traceDataSource/getDetail", // 数据源详情
  ZSZX__DELBYID: "/trace/w/traceDataSource/delById", // 数据源删除
  ZSZX__FINDLIST: "/trace/w/traceDataSource/findList", // 数据源 下拉

  ZSZX__APIFINDPAGE: "/trace/w/traceServiceMage/findPage", // API接口服务管理 分页查询
  ZSZX__SAVEFORAPI: "/trace/w/traceServiceMage/saveForApi", // API接口服务管理  新增
  ZSZX__APIDELBYID: "/trace/w/traceServiceMage/delById", // API接口服务管理 删除
  ZSZX__GETDETAILFORAPI: "/trace/w/traceServiceMage/getDetailForApi", // API接口服务管理 详情
  ZSZX__APIFIELDLIST: "/trace/w/traceServiceMage/fieldList", // API接口服务管理  字段配置 获取
  ZSZX__APISAVEFIELD: "/trace/w/traceServiceMage/saveField", // API接口服务管理  字段配置 保存
  ZSZX__APISERVICEFRESHEN: "/trace/w/traceServiceMage/serviceFreshen", // API接口服务管理  手动刷新 保存

  ZSZX__IMPFINDLIST: "/trace/w/traceServiceMage/findList", // 数据导入  采集服务 下拉
  ZSZX__IMPORTTEMPLATE: "/trace/w/dataImp/importTemplate", // 数据导入  下载导入模板
  ZSZX__IMPROTSAVE: "/trace/w/dataImp/improtSave", // 数据导入  导出数据验证

  ZSZX__IMPTEMPLETEINIT: "/trace/w/traceServiceMage/impTempleteInit", // 文件导入采集服务  导出数据验证
  ZSZX__IMPSAVEFORIMP: "/trace/w/traceServiceMage/saveForImp", // 文件导入采集服务  保存
  ZSZX__GETDETAILFORIMP: "/trace/w/traceServiceMage/getDetailForImp", // 文件导入采集服务  保存

  ZSZX__FINDRECORDPAGE: "/trace/w/traceDataCj/findRecordPage", // api调用接口记录  分页查询
  ZSZX__CANCELSAVE: "/trace/w/traceDataCj/cancelSave", //文件导入记录 撤销保存记录

  ZSZX__CJFINDPAGE: "/trace/w/traceDataCj/findPage", //采集数据管理  分页列表查
  ZSZX__CJEXPORTDATA: "/trace/w/traceDataCj/exportData", //采集数据管理 详情 导出
  // ZSZX__CJSHOWDATEFIELD: "/trace/w/traceDataCj/showDateField", //采集数据管理 表头
  ZSZX__CJSHOWDATAPAGE: "/trace/w/traceDataCj/showDataPage", //采集数据管理 详情 表头内容

  // 数字养殖
  EQUMONITOR_SELEQUMONITORLIST: "/difam/w/equMonitor/selEquMonitorList", //设备监测列表，/企业基地 下的设备列表/ 企业基地地块 下的设备列表
  SEARCH_GETLASTDATAPOINT: "/difam/n/equ/search/getLastDataPoint", // 获取设备最近一条数据
  ENTPBASEIOT_FINDINFO: "/difam/w/entpBaseIot/findInfo", // 获取设备信息
  SEARCH_GETEQUONLINESTATUS: "/difam/n/equ/search/getEquOnlineStatus", // 获取设备在线状态： 0 离线、1 在线
  EARTYWANMING_FINDPAGELIST: "/difam/w/eartyWanming/findPageList", //获取预警记录列表
  PLANTFARMWORKSITUATION_PAGE: "/simple-api/n/wlt/bigdata/base/plantFarmworkSituation/page", //获取农情列表
  FARMWORK_FINDPAGE: "/simple-api/n/wlt/bigdata/base/plant/farmwork/findpage", //获取农事列表
  HARVESTINFO_PAGE: "/simple-api/n/wlt/bigdata/base/plant/harvestInfo/page", //获取采收列表
  W_ENTPBASECAMERA_FINDPAGELIST: "/difam/w/entpBaseCamera/findPageList", //基地摄像头分页查询列表
  BASE_INFO: "/difam/w/base/info", // 基地信息查询
  // "ENTPBASEMAGE_FINDLIST": "/difam/w/entpBaseMage/findList",//基地查询列表
  SEARCH_DATEPOINTSTATISTICS: "/difam/n/equ/search/datePointStatistics", //获取设备历史数据
  //新科右大数据
  STANDARD_FINDWHOLECHAINLIST_NOPAGE : "/standard/n/findWholeChainListNoPage",//查询产业环节第一级查询产业环节中的数量
  STANDARD_FISTIDUSTRY: "/standard/n/fistIdustry",//查询产业环节第一级查询产业环节中的数量
  STANDARD_SELSTAN_COUNT_MAGE: "/standard/n/selStanCountByLinkMage",

    // 兴隆大数据 交易一张图 zql
    BIGDATA_TRADE_CHANNELSALE: "/simple-api/n/xl/bigdata/trade/channelSale", // 年度渠道销售情况 时间轴
    BIGDATA_TIMEAXIS: "/simple-api/n/xl/bigdata/timeAxis", // 大数据中心-时间轴查询
    BIGDATA_TRADE_YEARSALE: "/simple-api/n/xl/bigdata/trade/yearSale", // 年度销售情况-月度情况
    BIGDATA_TRADE_INDUSTRY: "/simple-api/n/xl/bigdata/trade/industry", // 总交易通道
    BIGDATA_TRADE_CATGSALE: "/simple-api/n/xl/bigdata/trade/catgSale", // 年度品类交易情况
    BIGDATA_TRADE_FINDLIST: "/simple-api/n/xl/bigdata/trade/findList", // 查询渠道订单
    BIGDATA_TRADE_YEARPRICE: "/simple-api/n/xl/bigdata/trade/yearPrice", // 年度山楂平均收货价格
  
    // 基地一张图
    BIGDAT_BASE_BASEDATA: "/simple-api/n/xl/bigdata/base/baseData", // 主要数据指标-设备类型占比图

    BIGDAT_BASE_FINDLIST: "/simple-api/n/xl/bigdata/base/findList", // 大数据查询全部基地列表
    
    BIGDAT_BASE_BASEAREA: "/simple-api/n/xl/bigdata/base/baseArea", // 种植基地面积(亩)前方四类型
    
    BIGDAT_BASE_BASEAREAFINDLIST: "/simple-api/n/xl/bigdata/base/baseAreaFindList", // 种植基地面积(亩)后方
    BIGDAT_BASE_FINDONE: "/simple-api/n/xl/bigdata/base/findOne", // 基地详情

    // 肉牛产业链
    KY_BEEF_YEARLIST: "/simple-api/n/ky/beef/yearList", // 年列表
    KY_BEEF_BEEFGROW: "/simple-api/n/ky/beef/beefGrow", // 肉牛产业发展
    KY_BEEF_CITYLIST: "/simple-api/n/ky/beef/cityList", // 各乡镇分布情况
    KY_BEEF_BRANDLIST: "/simple-api/n/ky/beef/brandList", // 品牌面板
    KY_INDUSTRY_FINDINFO: "/simple-api/n/ky/industry/findInfo", // 产业园大数据查询

    // 乌拉特 交易一张图 zql
    WLT_BIGDATA_TRADE_CHANNELSALE: "/simple-api/n/wlt/bigdata/trade/channelSale", // 年度渠道销售情况 时间轴
    WLT_BIGDATA_TIMEAXIS: "/simple-api/n/xl/bigdata/timeAxis", // 大数据中心-时间轴查询
    WLT_BIGDATA_TRADE_YEARSALE: "/simple-api/n/wlt/bigdata/trade/yearSale", // 年度销售情况-月度情况
    WLT_BIGDATA_TRADE_INDUSTRY: "/simple-api/n/wlt/bigdata/trade/industry", // 总交易通道
    WLT_BIGDATA_TRADE_FINDLIST: "/simple-api/n/wlt/bigdata/trade/findList", // 查询渠道订单
    WLT_BIGDATA_TRADE_SALENAME: "/simple-api/n/wlt/bigdata/trade/saleName", // 年度品类交易情况
    // WLT_BIGDATA_TRADE_FINDLIST: "/simple-api/n/w'l't/bigdata/trade/findList", // 查询渠道订单
    WLT_BIGDATA_TRADE_AREASALE: "/simple-api/n/wlt/bigdata/trade/areaSale", // 年度销售地区占比
    
    //大数据页面数值维护接口
    
    N_BIGDATA_CONFIG: "/simple-api/n/xl/bigdata/config", // 大数据页面数值维护接口
    N_BIGDATA_CONFIGUPDATE: "/simple-api/n/xl/bigdata/configUpdate", // 大数据页面数值维护接口

    //全球商通中心大数据
    N_QPSTZX_SJFX_QGCDFBLIST: "/simple-api/n/qpstzx/sjfx/qgcdfbList", // 全国产地分布
    N_QPSTZX_SJFX_TRACEFLOW: "/simple-api/n/qpstzx/sjfx/traceFlow", // 全国交易流向


    QPSTZX_CONFIG: "/simple-api/n/qpstzx/config", // 商通大数据页面数值维护接口
    QPSTZX_CONFIGUPDATE: "/simple-api/n/qpstzx/configUpdate", //商通 大数据页面数值维护接口
    // 商通 交易一张图 zcx
    QPSTZX_BIGDATA_TRADE_CHANNELSALE: "/simple-api/n/qpstzx/bigdata/trade/channelSale", // 年度渠道销售情况 时间轴
    QPSTZX_BIGDATA_TRADE_YEARPRICE: "/simple-api/n/qpstzx/bigdata/trade/yearPrice", // 年度平均收货价格
    QPSTZX_BIGDATA_TRADE_INDUSTRY: "/simple-api/n/qpstzx/bigdata/trade/industry", // 总交易通道
    QPSTZX_TRADE_COMMSALE: "/operations/w/trade/commSale", //交易产品销售排名
    QPSTZX_BIGDATA_TRADE_CHANNELSALE: "/simple-api/n/qpstzx/bigdata/trade/channelSale", // 年度渠道销售情况 时间轴
    QPSTZX_BIGDATA_TRADE_SALENAME: "/simple-api/n/qpstzx/bigdata/trade/saleName", // 年度品类交易情况
    QPSTZX_BIGDATA_TRADE_YEARSALE: "/simple-api/n/qpstzx/bigdata/trade/yearSale", // 年度销售情况-月度情况
    QPSTZX_BIGDATA_TRADE_AREASALE: "/simple-api/n/qpstzx/bigdata/trade/areaSale", // 年度销售地区占比
    QPSTZX_BIGDATA_TRADE_FINDLIST: "/simple-api/n/qpstzx/bigdata/trade/findList", // 查询渠道订单




};
module.exports = Api;
